<template>
  <Button :class="$style.PayButton" @click="handlePay" :loading="paying"
    >立即支付<span :class="$style.Price">￥{{ price || '...' }}</span></Button
  >
</template>

<script lang="ts" setup>
  import { watch, onUnmounted, ref } from 'vue';
  import { useMobilePay } from '../paymemt-modal/hooks/useMobilePay';
  import { Button, message } from 'ant-design-vue';
  import { getApi } from '../init';

  const props = defineProps({
    agree: {
      type: Boolean,
      default: false,
    },

    skuId: {
      type: String,
      default: null,
    },

    channel: {
      type: String,
      required: true,
    },

    wxConfig: {
      type: Object,
      required: true,
    },

    zfbConfig: {
      type: Object,
      required: true,
    },

    isActiveVipTab: {
      type: Boolean,
      default: false,
    },
  });

  const emits = defineEmits(['success']);

  const { pay } = useMobilePay();
  const price = ref();
  let isEndPolling = false;

  function startPolling(payCode: string) {
    isEndPolling = false;
    polling(payCode);
  }
  function endPolling() {
    isEndPolling = true;
  }

  // 获取价格
  async function getPrice() {
    const result = await getApi().aiadTransactionsApi.getMagicBeanSkuPrice({
      skuId: props.skuId,
    });
    price.value = result.price;
  }

  async function polling(payCode: string) {
    if (isEndPolling) return;

    const result = await getApi().tcQrCodeApi.getTransactionCode({
      code: payCode,
    });

    // 支付成功
    if (result.status === 'success') {
      emits('success', result);
      return;
    }

    setTimeout(() => {
      polling(payCode);
    }, 1000);
  }

  // 获取支付code
  const payCode = ref();
  async function getPayCode() {
    payCode.value = await getApi().tcQrCodeApi.transactionCode({
      skuId: props.skuId,
    });
  }

  // 点击立即支付
  const paying = ref(false);
  async function handlePay() {
    if (!props.agree) {
      if (props.isActiveVipTab) {
        message.warn('请先仔细阅读并同意《支付协议》《会员服务协议》');
      } else {
        message.warn('请先仔细阅读并同意《支付协议》');
      }

      return;
    }
    paying.value = true;

    await pay({
      orderChannel: props.channel,
      payCode: payCode.value,
      wxConfig: props.wxConfig,
      zfbConfig: props.zfbConfig,
    });

    setTimeout(() => {
      paying.value = false;
    }, 1000);
  }

  watch(
    () => props.skuId,
    async (v) => {
      if (v) {
        await Promise.all([getPrice(), getPayCode()]);
        startPolling(payCode.value);
      }
    },
    {
      immediate: true,
    },
  );

  onUnmounted(() => {
    endPolling();
  });
</script>

<style lang="less" module>
  .PayButton {
    background: linear-gradient(94.36deg, #dc8647 0%, #c75241 99.73%) !important;
    width: 100%;
    height: 48px !important;
    font-size: 16px;
    font-weight: 400;
    line-height: 22px;
    display: flex !important;
    align-items: center;
    justify-content: center;
    color: rgba(255, 255, 255, 0.85) !important;
    opacity: 1 !important;
    border-radius: unset !important;
    overflow: hidden !important;
  }

  .Price {
    margin-left: 8px;
    font-size: 16px;
    font-weight: 500;
    line-height: 22px;
  }
</style>
